import React, { useState } from "react";
import { LoadingButton } from "@mui/lab";
import MaterialSymbol from "../icons/material-symbol";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
  title?: string;
  description?: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  align?: "center" | "bottom";
  closeButton?: boolean;
};

function MobileConfirmPopup({
  open,
  onClose,
  onConfirm,
  title = "Confirm",
  description = "Are you sure?",
  confirmText = "Yes",
  cancelText = "No",
  align,
  closeButton, 
}: Props) {
  const [loading, setLoading] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  if (!open) return null;

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  const handleClose = () => {
    setIsClosing(true);

    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 350);
  };

  return (<div
  className={`mobile-modal-overlay ${
    align === "bottom" ? "mobile-modal-bottom" : "mobile-modal-center"
  } ${isClosing ? "closing" : ""}`}
  onClick={handleClose}
>
  
    <div
      className={`mobile-modal-container ${align === "bottom" ? "mobile-modal-container-bottom" : ""}  ${isClosing ? "closing" : ""}`}
      onClick={(e) => e.stopPropagation()}
    >
      {align === "bottom" &&
        <div className="mobile-modal-icon"></div>
      }
      {/* Close */}
      {closeButton && 
        <span className="mobile-modal-close" onClick={handleClose}>
          <MaterialSymbol iconName="close" fontweight="200" />
        </span>
      }
        
      {/* Icon */}
      {/* <div className="mobile-modal-icon">?</div> */}

      {/* Title */}
      <h3 className="mobile-modal-title">{title}</h3>

      {/* Description */}
      <div className="mobile-modal-desc">
        {typeof description === "string" ? (
          description.split("\n").map((line, i) => (
            <p key={i}>{line}</p>
          ))
        ) : (
          description
        )}
      </div>

      {/* Actions */}
      
      <div className="mobile-modal-actions">
        {cancelText &&
        <button
          className="mobile-modal-btn mobile-modal-cancel"
          onClick={handleClose}
          disabled={loading}
        >
          {cancelText}
        </button>
        }
        {confirmText &&
          <LoadingButton
            className="mobile-modal-btn mobile-modal-confirm"
            loading={loading}
            variant="contained"
            onClick={handleConfirm}
          >
            {confirmText}
          </LoadingButton>
        }
      </div>
    </div>
  </div>


  );
}

export default MobileConfirmPopup;